module.exports = "/_next/static/images/mastercard_logo-dc6016cd26dfd134e6546001debfdbba.svg";